import { render, staticRenderFns } from "./CurrencyChoice.vue?vue&type=template&id=6cdc10b2"
import script from "./CurrencyChoice.vue?vue&type=script&lang=js"
export * from "./CurrencyChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports